let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4aQ01")).then(() => parcelRequire('2eFGH'));